// ModalCarrinho.js
import React, { useEffect, useContext } from "react";
import { useModal } from "../../services/context/ModalContext";
import { CarrinhoContext } from "../../services/context/CarrinhoContext";
import "./ModalCarrinho.css";
import Fechar from "../../assets/imgs/fechar.png";

const ModalCarrinho = () => {
  const { modalData, closeModal } = useModal();
  const { totalItens, valorTotal } = useContext(CarrinhoContext);

  useEffect(() => {
    if (modalData) {
      const timeoutId = setTimeout(() => {
        closeModal();
      }, 2000);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [modalData, closeModal]);

  if (!modalData) return null;

  return (
    <div className="modal-wrapper">
      <div className="modal-carrinho">
        <button onClick={closeModal}>X</button>
        <div className="modal-content d-flex">
          <img
            className="products-img"
            src={`https://insigneacademica.com.br/api/public/${modalData.image}`}
            alt="productImage"
          ></img>
          <div className="info-produto">
            <p>{modalData.titulo}</p>
            <div>
              <p>1x R${modalData.preco}</p>
            </div>
            <p>
              <strong>Adicionado com sucesso!</strong>
            </p>
          </div>
        </div>
        <div className="modal-info">
          <p>Total({totalItens} itens):</p>
          <p>R${valorTotal.toFixed(2)}</p>
        </div>
      </div>
    </div>
  );
};

export default ModalCarrinho;
